import classes from "./PixQrCode.module.scss";
import { useEffect, useContext, useState } from "react";
import InputTextCopy from "../../../../../UI/Inputs/InputTextCopy/InputTextCopy";
import SystemContext from "../../../../../../context/SystemContext";
import useFetch from "../../../../../../hooks/useFetch";
import * as kApi from "../../../../../../constants/api";
import { useDispatch, useSelector } from "react-redux";
import triangleWarning from "./../../../../../../assets/images/triangle_warning.svg";
import ModalPixWaitPayment from "./ModalPixWaitPayment/ModalPixWaitPayment";
import { useTranslation } from "react-i18next";
import { GoAlertFill } from "react-icons/go";


const PixQrCode = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const payload = useSelector((state) => state.purchase);
  const [stateServer, setStateServer] = useState(0);
  const { PixResponse, openModalWaitPayment, setOpenModalWaitPayment, setPurchaseInfo, PurchaseInfo,changePropertyUrl } =
    useContext(SystemContext);

  const [OrderStatus, , , _fetchOrderStatus] = useFetch({
    autoInit: false,
  });
  useEffect(() => {
    changePropertyUrl("",{etapa:"QrCode",metodoPagamento:"pix"});
  },[]);


  const CheckOrderUpdate = (order_id) => {
    if (payload.purchase.step === "PixQrCode") {
      setTimeout(() => {
        if (!OrderStatus || OrderStatus?.status !== "PG" && payload.purchase.step === "PixQrCode") {
          setStateServer(0);
          _fetchOrderStatus({
            url: kApi.API_URL_GET_ORDER(order_id),
            method: "GET",
          });
        }
      }, 10000);
    }

  };

  useEffect(() => {
    if (PixResponse && PixResponse?.status === "AP") {
      if (OrderStatus?.status === "PG" || OrderStatus?.status === "CO") {
        setPurchaseInfo({
          ...PurchaseInfo,
          "SuccessState": "processed"
        })

        dispatch({
          type: "PURCHASE",
          purchase: {
            content: "PurchaseSuccess",
            step: "PurchaseSuccess",
          },
          planInfo: {
            orderStatusPix: OrderStatus.next_charge,
            pixIsPaid: true,
          },
        });
        // AddTagGoogle("purchase", UserCart, true, Periodicity, {
        //   transaction_id: PixResponse.order_id,
        //   affiliation: "Afinando o Cérebro",
        // });
      } else if (stateServer === 0) {
        setStateServer(1);
        CheckOrderUpdate(
          PixResponse.OrderId ? PixResponse.OrderId : PixResponse.order_last_id
        );
      }
    }
  }, [OrderStatus]);

  return (
    <>
      <div className={classes.PixQrCode}>
        <ModalPixWaitPayment
          openModalWaitPayment={openModalWaitPayment}
          setOpenModalWaitPayment={setOpenModalWaitPayment}
        />
        <div className={classes.OptionOne}>
          {t("purchase.option_one_qr_code")}
        </div>
        <img
          data-testid="payment_pix_qrCode_img"
          className={classes.QrCode}
          src={PixResponse?.qrcode}
          alt=""
        />
        <div className={classes.DescListQr}>
          <li>{t("purchase.open_your_bank_app")}</li>
          <li>{t("purchase.look_for_the_option_to_read_the_qr_code")}</li>
          <li>{t("purchase.confirm_payment")}</li>
          <li>
            <strong>{t("purchase.important")}</strong> {t("purchase.pix_and_invoice_notice")}
          </li>

        </div>
        <div className={classes.OptionTwo}>
          {t("purchase.option_two_qr_code")}
        </div>
        {/* <div className={classes.CopyButton}>btn copy</div> */}
        <InputTextCopy
          classSon={classes.CopyButton}
          defaultValue={PixResponse?.emv}
        />
        <div className={classes.DescListCopyBtn}>
          <li>{t("purchase.click_the_copy_code_button")}</li>
          <li>{t("purchase.look_for_the_pay_pix_area_with_copy_and_paste")}</li>
          <li>
            {t(
              "purchase.paste_the_code_check_the_amount_and_complete_the_payment"
            )}
          </li>
        </div>
        {payload.purchase.step === "PixQrCode" && (
          <div className={classes.WarningUnlockPlatform}>
            <img src={triangleWarning} alt="triangulo de atenção" />
            <div>{t("purchase.completing_the_purchase_with_pix")}</div>
          </div>
        )}
      </div>
    </>
  );
};
export default PixQrCode;
